export function getLang() {
  return $('html').attr('lang');
}

/*
export function setUrl(data){
    const referrer = document.referrer;
    let href= '';

    if(referrer) {
      href = getUriCombinedParams(referrer,{visitedIeNotice1: true});
    }

    const prevLink = document.getElementsByClassName('wrap-link')[0];
    prevLink.innerHTML = `
        <a class="link-previous" href="${href}">${data.support.btn.previous_page}</a>
    `;
}*/


export function getParameterByName(name) {
  name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)'),
      results = regex.exec(location.search);
  return results == null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}




/*
const getUriParams = uri => {
    if (uri.length < 1) return null;
    uri = uri.split('#')[0];

    let tmpArr = uri.split('?');
    if (tmpArr.length < 2) return null;

    let paramStr = tmpArr[1],
        params = paramStr.split('&');

    let keyValueArr,
        obj = {};
    for (let i = 0, max = params.length; i < max; ++i) {
        keyValueArr = params[i].split('=');
        if (keyValueArr.length <= 1) return null;

        obj[keyValueArr[0]] = keyValueArr[1];
    }

    return obj;
};*/


const getUriCombinedParams = (uri, parameters) => {

    if (!uri) return '';
    if (!parameters) return uri;

    var str = '';
    for (var key in parameters) {
        str += '&' + key + '=' + String(parameters[key]);
    }

    if (str === '') return uri;

    var tmpArr = uri.split('#'),
        hashStr = tmpArr[1] ? '#' + tmpArr[1] : '';

    uri = tmpArr[0];
    uri = (uri.indexOf('?') >= 0 ? uri + str : uri + '?' + str.substr(1)) + hashStr;

    return uri;
};



